<template>
<div class="PersonalAuthView">
    <el-alert v-if="authMsg !== '认证通过'" title="您未进行认证，请进行个人或企业认证即可获得更多权益" type="warning" show-icon></el-alert>
    <p class="title marginTop20">获得权益</p>
    <div class="equity_warp">
        <div v-for="(item,index) in equityList" :key="index">
            <img :src="item.icon" alt="">
            <h4 class="marginTop20">{{item.title}}</h4>
            <p>{{item.explain}}</p>
            <p>{{item.tip}}</p>
        </div>
    </div>
    <p class="title marginTop20">实名认证审核及费用</p>
    <div class="question_box">
        <div class="marginTop15"><img :src="icon0" alt=""><span>个人认证是那些人可以申请</span></div>
        <p class="marginTop15">仅个人申请</p>
        <div class="marginTop15"><img :src="icon0" alt=""><span>实名认证审核需要多久？</span></div>
        <p class="marginTop15">资料提交后，3~7个工作日即可完成审核；届时可能会有电话回访，请留意来电。</p>
        <div class="marginTop15"><img :src="icon0" alt=""><span>认证需要收费吗？</span></div>
        <p class="marginTop15">认证是免费的。</p>
    </div>
    <div class="btn_box">
        <el-button type="warning" @click="personalAuth">立即个人认证</el-button>
    </div>
</div>
</template>

<script>
export default {
    name: 'PersonalAuthView',
    data() {
        return {
            icon0: require('@/common/images/other/icon0@2x.png'),
            equityList: [
                {title: '加橙V标识', icon: require('@/common/images/other/icon1@2x.png'), explain: '防止假冒，增加可信度', tip: ''},
                {title: '内容优先审核', icon: require('@/common/images/other/icon2@2x.png'), explain: '工作时间4小时完成审核 ', tip: '(非认证用户为24小时)'},
                {title: '刷新内容排名', icon: require('@/common/images/other/icon3@2x.png'), explain: '1次/天，内容排名靠前', tip: ''},
                {title: '可申请强力推荐', icon: require('@/common/images/other/icon4@2x.png'), explain: '仅限认证用户', tip: '(可联系运营部申请)'},
                {title: '一键通知粉丝', icon: require('@/common/images/other/icon5@2x.png'), explain: '快速向粉丝宣传内容', tip: ''},
                {title: '短信、邮件群发', icon: require('@/common/images/other/icon6@2x.png'), explain: '定向精准营销', tip: ''},
                {title: '一键通知粉丝', icon: require('@/common/images/other/icon7@2x.png'), explain: '快速向粉丝宣传内容', tip: ''}
            ]
        }
    },
    props: {
        authMsg: {
            default: ''
        }
    },
    mounted() {
    },
    methods: {
        personalAuth() {
            this.$router.push('/accountMgt/accountAuth/personalAuth')
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.PersonalAuthView {
    .marginTop20{
        margin-top: 20px;
    }
    .marginTop15{
        margin-top: 15px;
    }
    .title{
        border-left: 2px solid #409EFF;
        padding-left: 10px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
    }
    .equity_warp{
        padding: 0px 10px 10px 10px;
        display: flex;
        flex-wrap: wrap;
        &>div{
            width: 180px;
            height: 204px;
            margin-top: 20px;
            margin-right: 50px;
            // cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            img{
                width: 60px;
                height: 60px;
                margin-top: 30px;
            }
            h4{
                font-size:16px;
                color: #303133;
                font-weight: bold;
                margin-bottom: 10px;
            }
            p{
                width: 128px;
                font-size: 12px;
                color: #909399;
                line-height:18px;
                text-align: center;
            }
        }
        &>div:hover{
            box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -webkit-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -ms-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -o-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
            -moz-box-shadow: 4px 4px 20px 0px rgba(0,14,63,0.16);
        }
    }
    .question_box{
        padding-top: 5px;
        &>div{
            padding-left: 10px;
            display: flex;
            align-items: center;
            img{
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
            span{
                 font-size: 16px;
                font-weight: bold;
                color: #409EFF;
            }
        }
        &>p{
            padding-left: 40px;
            color: #606266;
        }
    }
    .btn_box{
        margin-top: 40px;
        margin-bottom: 20px;
    }
}
</style>
